import React from 'react';

type Props = {
  emoji: string;
  label?: string;
};

/**
 * Based on the: https://medium.com/@seanmcp/️-how-to-use-emojis-in-react-d23bbf608bf7
 */
export default function Emoji({ emoji, label = '' }: Props): JSX.Element {
  return (
    <span
      role='img'
      aria-label={label}
      aria-hidden={!label}
      data-testid='emoji-container'
    >
      {emoji}
    </span>
  );
}
